export const FETCH_GLOBAL_ATTRIBUTES_REQUEST = "FETCH_GLOBAL_ATTRIBUTES_REQUEST";
export const FETCH_GLOBAL_ATTRIBUTES_SUCCESS = "FETCH_GLOBAL_ATTRIBUTES_SUCCESS";
export const FETCH_GLOBAL_ATTRIBUTES_ERROR = "FETCH_GLOBAL_ATTRIBUTES_ERROR";
export const UPDATE_GLOBAL_ATTRIBUTES = "UPDATE_GLOBAL_ATTRIBUTES";
